import { useTheme } from "@mui/material"
import {
  ChipList,
  type ChipListProps,
  type ReferentialCode,
  type TableChipProps,
  labelOf,
} from "@pharmupp/p3-front-commons"
import type { FC } from "react"
import { newsCreatorTypeEnum } from "../../commons"
import { ListChip } from "../../core"
import type { ApiFormPostReceived } from "../model"

export const NewsCreatorChip = ({
  creatorType,
  laboratoryId,
  activeLaboratories,
  ChipElement = ListChip,
}: Pick<ApiFormPostReceived, "creatorType" | "laboratoryId"> & {
  activeLaboratories: ReferentialCode<number>[]
  ChipElement?: FC<TableChipProps>
}) => {
  const theme = useTheme()
  if (creatorType !== "LABORATORY_CONTACT" && creatorType !== "PRESIDENT_UPP") {
    return null
  }

  const list: ChipListProps<TableChipProps>["chips"] = [
    {
      label: labelOf(newsCreatorTypeEnum, creatorType),
      fontColor: newsCreatorTypeEnum[creatorType].color,
    },
  ]

  if (creatorType === "LABORATORY_CONTACT" && laboratoryId) {
    const lab = activeLaboratories.find((lab) => laboratoryId === lab.code)

    if (lab) {
      list.push({
        label: lab.label,
        fontColor: theme.palette.primary.main,
        borderColor: theme.palette.common.cloudGray,
      })
    }
  }

  return <ChipList chips={list} ChipElement={ChipElement} />
}
